// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-spinkit/css/folding-cube.css
// module id = 334
// module chunks = 0